import { BASE_URL } from "config";
import * as baseApi from "./_base";

export const endpoints = {
    list: `${BASE_URL}/api/v1/message/`,
    detail: (id) => `${BASE_URL}/api/v1/message/${id}/`,
};

export const messageLoad = (token, payload) => baseApi.ListLoad(endpoints.list, token, payload);
export const messageDetailLoad = (token, { id }) => baseApi.DetailLoad(endpoints.detail, token, { id });
export const messageUpdate = (token, data) => baseApi.Update(endpoints.list, endpoints.detail, token, data);
export const messageDelete = (token, { id }) => baseApi.Delete(endpoints.detail, token, { id });
